import { CreditCard } from "@medusajs/icons"
import React from "react"

import Bancontact from "@modules/common/icons/bancontact"
import Ideal from "@modules/common/icons/ideal"
import PayPal from "@modules/common/icons/paypal"

/* Map of payment provider_id to their title and icon. Add in any payment providers you want to use. */
export const paymentInfoMap: Record<string, { title: string; icon: React.JSX.Element }> = {
  stripe: {
    title: "Credit card",
    icon: <CreditCard />,
  },
  "stripe-ideal": {
    title: "iDeal",
    icon: <Ideal />,
  },
  "stripe-bancontact": {
    title: "Bancontact",
    icon: <Bancontact />,
  },
  paypal: {
    title: "PayPal",
    icon: <PayPal />,
  },
  manual: {
    title: "Test payment",
    icon: <CreditCard />,
  },
  // Add more payment providers here
}

// Add currencies that don't need to be divided by 100
export const noDivisionCurrencies = [
  "krw",
  "jpy",
  "vnd",
  "clp",
  "pyg",
  "xaf",
  "xof",
  "bif",
  "djf",
  "gnf",
  "kmf",
  "mga",
  "rwf",
  "xpf",
  "htg",
  "vuv",
  "xag",
  "xdr",
  "xau",
]

export const baseHeaders = {
  "x-device-platform": "web",
  "x-app-version": "1",
  "x-app-version-code": "1",
}

export const MEDUSA_BACKEND_URL = process.env.NEXT_PUBLIC_MEDUSA_BACKEND_URL || "http://localhost:9000"
export const NEXT_PUBLIC_NELO_API_BASE_URL = process.env.NEXT_PUBLIC_NELO_API_BASE_URL || "http://localhost:8080"

export const PSEUDO_ID_COOKIE = "pseudo_id"
export const PSEUDO_ID_HEADER = "x-user-pseudo-id"
export const PSEUDO_ID_HEADER_LEGACY = "user-uuid"
export const AUTH_TOKEN_COOKIE = "nelo_auth_token"
export const X_AUTH_TOKEN = "x-auth-token"
export const UTM_PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "utm_ad", "utm_id"]

export const AWS_REGION = "us-east-1"
export const AWS_IDENTITY_POOL_ID = "us-east-1:b0c7ff1b-6647-4137-acb3-21d72412329d"
